import React from 'react';
import { Popover, PopoverProps } from '@material-ui/core';

export interface DropdownProps extends PopoverProps {
  className?: string;
  popover: React.ReactNode;
}

/**
 * Dropdown
 * see https://material-ui.com/components/popover/
 */
class Dropdown extends React.Component<DropdownProps, {}> {
  constructor(props: DropdownProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { open, children, popover, ...props } = this.props;

    return (
      <>
        {children}
        <Popover open={open} {...props}>
          {popover}
        </Popover>
      </>
    );
  }
}

export default Dropdown;
